var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankProductAndServiceProductsCatalog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-3116.000000, -966.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bank-Product-and-Service/Products-catalog",
    transform: "translate(3116.000000, 966.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,10 L26,10 L26,5 L21,5 L21,10 Z M12,10 L17,10 L17,5 L12,5 L12,10 Z M12,19 L17,19 L17,14 L12,14 L12,19 Z M31,3 L31,32 L10,32 C8.343,32 7,30.657 7,29 L7,0 L28,0 C29.657,0 31,1.343 31,3 L31,3 Z M7,32 L4,32 C2.343,32 1,30.657 1,29 L1,3 L4,3 L4,29 C4,30.657 5.343,32 7,32 L7,32 Z",
    id: 141
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankProductAndServiceProductsCatalog);
export default __webpack_public_path__ + "static/media/bank-product-and-service-products-catalog.43e15114.svg";
export { ForwardRef as ReactComponent };